import React, {useCallback, useContext} from 'react';
import {useNavigate, useParams} from 'react-router-dom';

import {Headline} from 'src/admin-rights-service/components/headline';
import {Skeleton} from 'src/components/skeleton';
import {mapDateFormat} from 'src/utils/mapDateFormat';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {FormattedDate} from '@pb/kit-component-formatters';
import {Group} from '@pb/kit-component-group';
import {LocaleContext} from '@pb/kit-context-locale';


import {ProfileName} from '../../components/profile-name';

import {ProfileHistoryHeadlineSkeleton} from './profile-history-headline.skeleton';

import type {ProfileChangeRecord} from 'src/openapi/admin/models/ProfileChangeRecord';

type Props = {
    isLoading: boolean,
    profileId: number,
    profileName: string,
    profileHistory: ProfileChangeRecord[],
};

export const ProfileHistoryHeadline = (props: Props) => {
    const {
        isLoading,
        profileId,
        profileName,
        profileHistory,
    } = props;

    const {locale} = useContext(LocaleContext);

    const queryParams = useParams<{recordId: string}>();
    const recordId = queryParams.recordId ? +queryParams.recordId : -1;

    const navigate = useNavigate();

    const selectRecord = useCallback((newRecordId: number) => {
        navigate(`/roles/${profileId}/history/${newRecordId}`);
    }, [navigate, profileId]);

    return (
        <Skeleton shown={isLoading} view={<ProfileHistoryHeadlineSkeleton/>}>
            <Headline
                prefix={(
                    <Group alignItems="center">
                        <div style={{width: 310}}>
                            <ComboBox value={recordId} onChange={selectRecord}>
                                {profileHistory.map(record => (
                                    <ComboboxItem
                                        key={record.eventId}
                                        value={record.eventId}
                                        caption={[
                                            record.operationDescription,
                                            FormattedDate.format({
                                                value: record.eventTime,
                                                format: mapDateFormat(locale.dateFormat, 'WORD', 'DATE_TIME'),
                                            }),
                                        ].join(' ')}
                                    />
                                ))}
                            </ComboBox>
                        </div>
                        <ProfileName
                            disabled={true}
                            profileName={profileName}
                            onSetName={() => undefined}
                        />
                    </Group>
                )}
                header=""
            />
        </Skeleton>
    );
};
